import React from 'react';
import QRCode from '../qrCodeForm/QRCodeForm';

const ProfilePage = () => {
    return (
        <div>
            <QRCode />
        </div>
    );
};

export default ProfilePage;